<template>
	<div class="blockItem">
		<div class="blockBody">
			<div class="blockTitle">
				<div class="blockTitleL">德育学校分布</div>
				<!-- <div class="blockTitleR">今日生病学生数：132</div> -->
			</div>

			<div class="echarts" id="lineSimple"></div>

			<div>

				<!-- <div class="map">
					<img style="width: 80%; height: auto" src="../assets/img/ouhai1.png" />
					<div class="point point1" v-if="point1Show">
						<div class="point11">
							<img style="width: 20px; height: auto" src="../assets/img/point.png" />
						</div>
						<div class="line"></div>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts';
	import geoJson from '@/assets/geoJson.json'
	import tools from "@/utils/tools";

	export default {
		data() {
			return {
				point1Show: true
			}
		},
		mounted() {
			this.setChart();
		},
		methods: {
			setChart() {
				echarts.registerMap('ouhai', geoJson);
				let myChart = echarts.init(document.getElementById('lineSimple'))
				let symbolSize = 20;
				let option = {
					tooltip: {
						trigger: 'item',
						position: 'top',
						padding: 0,
						backgroundColor: 'transparent',
						formatter: function(params, ticket, callback) {
							if (params.data.name) {
								return '<div style="background-image: url(/static/border.png);background-size: 100% 100%;background-repeat: no-repeat;width:200px;height:80px;color: #000000;transform: rotate(10deg);"><div style="color: #082F5E;font-size: 16px;line-height: 50px;margin: 0 12px">'+params.data.name+'</div><div style="color: #FFFFFF;font-size: 14px;margin-left: 32px">学期德育分：'+params.data.score+'</div></div>'
							}
							return
						},
					},
					/* tooltip: {
						trigger: 'item',
						padding: 0,
						formatter: '<div style="background: #FFFFFF;color: #000000;">{a}<br/>2222</div>'
					}, */
					toolbox: {
						show: false
					},
					visualMap: {
						show: false
					},
					xAxis: {
						show: false,
						min: 0,
						max: 1
					},
					yAxis: {
						show: false,
						min: 0,
						max: 1
					},
					series: [{
							type: 'effectScatter',
							symbolSize: 2,
							itemStyle: {
								color: '#3BD4FF'
							},
							rippleEffect: {
								scale: 18,
								color: '#3BD4FF'
							},
							data: [
								{
									name: "龙霞实验小学1",
									score: "1000",
									value: [0.3, 0.7]
								},
								{
									name: "龙霞实验小学2",
									score: "111",
									value: [0.7, 0.3]
								}
							],
							/* itemStyle: {
								normal: {
									color: '#F4E925',
									shadowBlur: 10,
									shadowColor: '#05C3F9'
								}
							},
							showEffectOn: 'render',
							rippleEffect: {
								brushType: 'stroke',
								scale: 4,
							}, */
							// hoverAnimation: true,
							
						},
						{
							name: '瓯海区',
							type: 'map',
							mapType: 'ouhai',
							data: [{
								name: '瓯海区',
								selected: true,
								emphasis: {
									label: {
										show: false
									},
									itemStyle: {
										areaColor: '#082F5E',
										shadowColor: '#025679',
										/* borderColor: '#3BD4FF',
										borderWidth: 1, */
										shadowOffsetY: 12,
										shadowOffsetX: -10,
									}
								}
							}],
							tooltip: {
								show: false
							},
						}
					]
				}
				myChart.setOption(option);
				tools.autoHover(myChart, option, 2, 4000);
				/* window.addEventListener("resize", function() {
					myChart.resize();
				}); */
			}
		},
	}
</script>

<style lang="less" scoped>
	.echarts {
		width: 100%;
		height: 100%;
		transform: rotate(-10deg);
		margin-top: -50px;
	}

	.map {
		text-align: center;
		/* animation: myfirst 10s;
		-moz-animation: myfirst 10s;
		-webkit-animation: myfirst 10s;
		-o-animation: myfirst 10s;
		animation-iteration-count: infinite; */
		position: relative;
		z-index: 1;

		.point {
			position: absolute;
			z-index: 2;

			&.point1 {
				top: 15%;
				left: 18%;

			}

			&.point2 {
				top: 170px;
				left: 320px;
			}

			&.point3 {
				top: 270px;
				left: 460px;
			}

			.point11 {
				position: absolute;
				z-index: 2;
				animation: myPoint 10s;
				animation-iteration-count: infinite;
			}

			.line {
				position: absolute;
				z-index: 2;
				bottom: -8px;
				left: 9px;
				height: 50px;
				width: 2px;
				background-color: red;
				/* animation: test 10s;
				animation-iteration-count: infinite; */
			}

			@keyframes myPoint {
				0% {
					transform: scale(0.5);
				}

				25% {
					transform: scale(0.8);
				}

				50% {
					transform: scale(1.2);
				}

				75% {
					transform: scale(0.8);
				}

				100% {
					transform: scale(0.5);
				}
			}

			@keyframes test {
				0% {
					height: 0;
					transform: translateY(0);
				}

				50% {
					height: 50px;
					transform: translateY(-100%);
				}

				100% {
					height: 0;
					transform: translateY(0);
				}
			}
		}

		@keyframes myfirst {
			0% {
				transform: scale(0.8) rotate(-10deg);
			}

			60% {
				transform: scale(1) rotate(0);
			}

			100% {
				transform: scale(0.8) rotate(-10deg);
			}
		}

		@-moz-keyframes myfirst

		/* Firefox */
			{}

		@-webkit-keyframes myfirst

		/* Safari 和 Chrome */
			{}

		@-o-keyframes myfirst

		/* Opera */
			{}
	}
</style>
